import { Box, Button, Heading } from '@hyphen/hyphen-components';

import { signInURL } from '../lib/api.js';

// Imported rather than referenced by path, so bun bundles it and rewrites the
// URL. A literal /assets/... path is served by the SPA catch-all instead — the
// browser asks for an image and gets the HTML shell back, with nothing in the
// console to say so.
import mark from '../../assets/static/logo.svg';

/**
 * The signed-out screen.
 *
 * Centred rather than pinned to the top, because it is the only thing on the
 * page — a card under a screenful of whitespace looks like a page that failed
 * to finish loading.
 */
const LABELS = { google: 'Sign in with Google', microsoft: 'Sign in with Microsoft' };

export function SignIn({ providers }) {
  // Google alone if the server said nothing: an older API than this app is
  // still one that signs people in, and a screen with no button at all is
  // worse than one offering the provider that has always been there.
  const offered = providers?.length ? providers : ['google'];
  return (
    <Box height="100vh" alignItems="center" justifyContent="center" padding="3xl">
      <Box
        width="100"
        maxWidth="24rem"
        padding="4xl"
        background="primary"
        borderWidth="sm"
        borderColor="subtle"
        radius="xl"
        shadow="sm"
        gap="2xl"
        alignItems="center"
      >
        <img src={mark} alt="" aria-hidden="true" width="72" height="72" />
        <Heading as="h1" size="md">Hyphen Trust Admin</Heading>
        <Box as="p" color="secondary" textAlign="center">
          Sign in to manage Hyphen Trust.
        </Box>
        {/*
          asChild renders the anchor with the button's styling merged onto it —
          Radix's Slot pattern, and what this library supports. `as` is not a
          prop it has, so it was silently dropped and this rendered a <button>
          that navigated nowhere.

          A link rather than a click handler because it navigates to Google:
          middle-click and open-in-new-tab work, and there is no state to manage.
        */}
        {offered.map((provider, index) => (
          <Button key={provider} asChild fullWidth variant={index === 0 ? 'primary' : 'secondary'}>
            <a href={signInURL(provider)}>{LABELS[provider] ?? `Sign in with ${provider}`}</a>
          </Button>
        ))}
      </Box>
    </Box>
  );
}
